import './Logo.css';
import React from 'react';
import { useAppContext } from '../../core/context';
import vippsLogo from './vipps-logo.svg';
import mobilepayTextLogo from './mobilepay-text-logo.svg';
import { Brand, getBrandFromQueryParamOrClaimsOrHost } from '../../core/context/claims';
import { useLanguageContext } from '../../core/locale/LanguageContext';

function Logo(): React.ReactNode {
  const languageContext = useLanguageContext();
  const context = useAppContext();
  const brand = getBrandFromQueryParamOrClaimsOrHost(context.claims);

  switch (brand) {
    case Brand.VIPPS:
      return (
        <img
          className="logo logo-vipps"
          alt={languageContext.getLocalizedText('logoTitle')}
          src={vippsLogo}
        />
      );
    case Brand.MOBILEPAY:
      return (
        <span className="logo logo-mobilepay">
          <img alt={languageContext.getLocalizedText('logoTitle')} src={mobilepayTextLogo} />
        </span>
      );
  }
}

export default Logo;
